import React, { Component } from 'react';

//import { Button, ButtonGroup, Container, Table } from 'reactstrap';

import Moment from 'moment';
import {  MDBTable, MDBTableHead, MDBTableBody, MDBContainer } from 'mdb-react-ui-kit';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import ModeEditIcon from '@mui/icons-material/ModeEdit';

import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Pagination from '@mui/material/Pagination';
import { Navigate } from "react-router-dom";


import Button from '@mui/material/Button';


import TextField from '@mui/material/TextField';

import AuthService from "../services/LoginService";

import ContractDataService from '../services/ContractService'
import { AddContract } from './AddContract';

class ContractList extends Component {

    constructor(props) {
        super(props);
        this.onChangeStartDate = this.onChangeStartDate.bind(this);
        this.onChangeEndDate = this.onChangeEndDate.bind(this);
        this.retrieveContracts = this.retrieveContracts.bind(this);
        this.refreshList = this.refreshList.bind(this);
        this.setActiveContract = this.setActiveContract.bind(this);
        this.removeAllContracts = this.removeAllContracts.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
        var tempDate = new Date();
        const currDate = tempDate.getFullYear() + '-' + (tempDate.getMonth() + 1) + '-' + tempDate.getDate();
        const oldDate = tempDate.getFullYear() - 1 + '-' + (tempDate.getMonth() + 1) + '-' + tempDate.getDate();

        this.state = {
            contracts: [],
            searchTitle: "",
            page: 1,
            count: 0,
            pageSize: 3,
            startDateFilter: Moment(oldDate).format('yyyy-MM-DD'),
            endDateFilter: Moment(currDate).format('yyyy-MM-DD'),
            redirect: null,
            currentUser: { username: "" },
            addContractShow : false
        };
        this.pageSizes = [3, 6, 9, 15, 25];
        this.remove = this.remove.bind(this);
    }




    componentDidMount() {

        const currentUser = AuthService.getCurrentUser();
        console.log(currentUser);
        if (!currentUser) {
            this.setState({ redirect: "/login" });
        } else {
            this.retrieveContracts();
        }


    }

    /*
    componentDidUpdate(){
        this.retrieveContracts();
    }
    */

    onChangeStartDate(e) {
        const startDateVal = e.target.value;
        console.log(startDateVal);
        //Moment.locale('en');        
        this.setState({
            startDateFilter: startDateVal,
        });
    }
    onChangeEndDate(e) {
        const endDateVal = e.target.value;
        //Moment.locale('fr');
        console.log(endDateVal);
        this.setState({
            endDateFilter: endDateVal,
        });
    }

    retrieveContracts() {
        const { startDateFilter, endDateFilter, page, pageSize } = this.state;
        const params = this.getRequestParams(startDateFilter, endDateFilter, page, pageSize);

        ContractDataService.getAll(params)
            .then((response) => {
                const { contracts, totalPages } = response.data;

                this.setState({
                    contracts: contracts,
                    count: totalPages,
                });
                console.log(response.data);
            })
            .catch((e) => {
                console.log(e);
            });
    }

    getRequestParams(startDateFilter, endDateFilter, page, pageSize) {
        let params = {};

        if (startDateFilter) {
            params["startDateFilter"] = startDateFilter;
        }
        if (endDateFilter) {
            params["endDateFilter"] = endDateFilter;
        }
        if (page) {
            params["page"] = page - 1;
        }

        if (pageSize) {
            params["size"] = pageSize;
        }

        return params;
    }

    async editPdf(id, num) {
        ContractDataService.buildPdfContract(id)
            .then(response => {
                return response.data;
            }).then((blob) => {
                const href = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', `contract-${num}.pdf`); //or any other extension
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }).catch((err) => {
                return Promise.reject({ Error: 'Something Went Wrong', err });
            });
    }

    async sendPdf(id, num) {
        ContractDataService.sendPdfContract(id)
            .then(response => {
                console.log(response.data);
                return response.data;
            }).catch((err) => {
                return Promise.reject({ Error: 'Something Went Wrong', err });
            });
    }

    refreshList() {
        this.retrieveContracts();
        this.setState({
            currentContract: null,
            currentIndex: -1,
        });
    }

    setActiveContract(contract, index) {
        this.setState({
            currentContract: contract,
            currentIndex: index,
        });
    }

    removeAllContracts() {
        ContractDataService.deleteAll()
            .then((response) => {
                console.log(response.data);
                this.refreshList();
            })
            .catch((e) => {
                console.log(e);
            });
    }

    handlePageChange(event, value) {
        this.setState(
            {
                page: value,
            },
            () => {
                this.retrieveContracts();
            }
        );
    }

    handlePageSizeChange(event) {
        this.setState(
            {
                pageSize: event.target.value,
                page: 1
            },
            () => {
                this.retrieveContracts();
            }
        );
    }


    async remove(id) {
        await fetch(`/api/v1/contracts/${id}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }).then(() => {
            let updatedContracts = [...this.state.contracts].filter(i => i.id !== id);
            this.setState({ contracts: updatedContracts });
        });
    }




    async searchContracts(start, end) {
        console.log(Moment(start).format('yyyy-MM-DD'));
        console.log(Moment(end).format('yyyy-MM-DD'));
        this.setState({
            startDateFilter: Moment(start).format('yyyy-MM-DD'),
            endDateFilter: Moment(end).format('yyyy-MM-DD'),
        });
        this.retrieveContracts();
    }


    render() {
        if (this.state.redirect) {
            return <Navigate to={this.state.redirect} />
        }

        const {
            contracts,
            page,
            count,
            pageSize,
            isLoading,
            startDateFilter,
            endDateFilter,
        } = this.state;

        let addContractClose = () => this.setState({addContractShow:false});


        if (isLoading) {
            return <p>Loading...</p>;
        }

        const ContractList = contracts.map(contract => {
            //console.log(contract);
            var sigdt = Moment(contract.signingDate).format('yyyy-MM-DD');
            var strdt = Moment(contract.startDate).format('yyyy-MM-DD');
            return <tr key={contract.id}>
                <td>{contract.num}</td>
                <td>{contract.student.lastName} &nbsp; {contract.student.firstName}</td>
                <td style={{ whiteSpace: 'nowrap' }}>{strdt}</td>
                <td>{sigdt}</td>
                <td>
                    <>
                        
                        <IconButton aria-label="edit"  color="primary"  >
                            <ModeEditIcon />
                        </IconButton>


                        <IconButton aria-label="pdf"  color="primary" onClick={() => this.editPdf(contract.id, contract.num)}>
                            <PictureAsPdfIcon />
                        </IconButton>
                        
                        <IconButton aria-label="emailpdf"  color="primary" onClick={() => this.sendPdf(contract.id, contract.num)}>
                            <AttachEmailIcon />
                        </IconButton>

                        <IconButton aria-label="delete"  color="primary" onClick={() => this.remove(contract.id)}>
                            <DeleteIcon />
                        </IconButton>

                       
                    </>

                </td>
            </tr>
        });






        const Item = styled(Paper)(({ theme }) => ({
            ...theme.typography.body2,
            textAlign: 'left',
            color: theme.palette.text.secondary,
            height: 60,
            lineHeight: '60px',
        }));


/*
<Item elevation={0}>  <Button variant="contained" onClick={()=> {this.setState({addContractShow: true}); console.log('clickeeeeed');}}>Nouveau</Button> </Item>
*/


        return (
            <div>

                <MDBContainer breakpoint='sm'>

                    <br />



                    <Grid container sx={{ color: 'text.primary' }}>
                        <Grid item xs={2}>
                            <Item elevation={0}><h4>Contrats</h4>  </Item>
                        </Grid>
                        <Grid item xs={4} >
                            

                        </Grid>
                        <Grid item xs={2} >
                            <TextField
                                id="e.target.value;"
                                label="Date Début"
                                type="date"
                                value={startDateFilter}
                                sx={{ width: 160, height: 100 }}
                                onChange={this.onChangeStartDate}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={2} >
                            <TextField
                                id="e.target.value;"
                                label="Date Fin"
                                type="date"
                                value={endDateFilter}
                                sx={{ width: 160 }}
                                onChange={this.onChangeEndDate}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={1} >
                            <Item elevation={0}>  <Button variant="contained" onChange={this.handlePageChange} onClick={this.retrieveContracts} > Chercher</Button> </Item>
                        </Grid>

                    </Grid>

                    <div >
                        <MDBTable align='middle' small >
                            <MDBTableHead className='table-primary'>
                                <tr>
                                    <th scope='col'>Numéro</th>
                                    <th scope='col'>Nom Stagiaire</th>
                                    <th scope='col'>Date Contrat</th>
                                    <th scope='col'>Date Signature</th>
                                    <th scope='col'>Actions</th>
                                </tr>
                            </MDBTableHead>
                            <MDBTableBody>
                                {ContractList}
                            </MDBTableBody>
                            <tfoot>
                                <tr>
                                    <td>
                                        {"Items per Page: "}
                                        <select onChange={this.handlePageSizeChange} value={pageSize}>
                                            {this.pageSizes.map((size) => (
                                                <option key={size} value={size}>
                                                    {size}
                                                </option>
                                            ))}
                                        </select>

                                    </td>
                                    <td></td>
                                    <td>
                                        <Pagination
                                            className="my-3"
                                            count={count}
                                            page={page}
                                            siblingCount={1}
                                            boundaryCount={1}
                                            variant="outlined"
                                            shape="rounded"
                                            onChange={this.handlePageChange}
                                        />

                                    </td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tfoot>
                        </MDBTable>
                    </div>
                </MDBContainer>

                <AddContract show={this.state.addContractShow} onHide={addContractClose} ></AddContract>
            </div>
        );
    }

}
export default ContractList;